module.exports = __webpack_public_path__ + "static/media/Inter-LightItalic.5e1e50b9.woff2";